/**
 * EDP Theme Overrides
 * Client-specific design tokens for EDP energy company
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/default/default.png';

export const edpThemeOverrides: ClientThemeOverrides = {
  clientId: 'edp',
  logo,
  clientName: 'EDP',
  palette: {
    light: {
      primary: {
        main: '#E30A18',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#b40014',
        contrastText: '#ffffff',
      },
      info: {
        main: '#ffee58',
      },
      error: {
        main: '#ac1900',
      },
      warning: {
        main: '#DAA520',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#E30A18',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
    dark: {
      primary: {
        main: '#ff3945',
        contrastText: '#000000',
      },
      secondary: {
        main: '#e03348',
        contrastText: '#ffffff',
      },
      background: {
        default: '#121212',
        paper: '#1E1E1E',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.87)',
        secondary: 'rgba(255, 255, 255, 0.6)',
      },
      info: {
        main: '#ffee58',
      },
      error: {
        main: '#ef5350',
      },
      warning: {
        main: '#ffa726',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#b30814',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
  },
  typography: {
    h1: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '1.2rem',
      fontWeight: 400,
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 400,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
            height: '100%',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.flat': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '& .MuiCardActions-root': {
              justifyContent: 'flex-end',
            },
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '1.5rem',
          fontWeight: 500,
        },
        h2: {
          fontSize: '1.2rem',
          fontWeight: 400,
        },
        h5: {
          fontSize: '1.1rem',
          fontWeight: 400,
          color: '#e10019',
        },
      },
    },
  },
  dataGrid: {
    highlightedCell: {
      backgroundColor: '#e1001aaf',
      textColor: '#ffffff',
    },
  },
};
